module.exports = __webpack_public_path__ + "static/media/search.a5753c02.svg";